import React from "react";
import { Avatar, IconButton, Typography } from "@mui/material";
import Cookies from "universal-cookie";
import removeAccessToken from "../../Helper/RemoveAccessToken/RemoveAccessToken";
import { ThemeProperties } from "../../Theme/ThemeProperties";
import Vammo from "../../Assets/Images/Sidebar/VammoLogoBlack.svg";
import Bnext from "../../Assets/Images/Sidebar/bnext.svg";
import Cker from "../../Assets/Images/Sidebar/ckers-logo.png";
import { getOrgBranding } from "../../Helper/Organization/Branding";

function ProfileAvatar(props) {
  const cookies = new Cookies();

  const GetAvatar = () => {
    return (
      <Avatar
        style={{
          height: "27px",
          width: "27px",
          backgroundColor: "#FF977A",
          border: `  1px solid ${
            props.openProfilePopup
              ? ThemeProperties.purple
              : ThemeProperties.white
          }`,
        }}
      >
        <Typography
          sx={{
            display: "flex",
            textAlign: "center",
            color: "#fff",
            fontSize: "14px",
          }}
        >
          {cookies.get("name") === undefined
            ? removeAccessToken()
            : cookies.get("name").charAt(0)}
        </Typography>
      </Avatar>
    );
  };

  // maxHeight keeps a tall logo inside the 48px toolbar - without it the app bar
  // grows and its primary background shows as a strip under the header. Only the
  // org-meta path passes it, so the bundled logos keep their existing spacing.
  const OrgLogoComponent = ({ icon, width, maxHeight }) => {
    return <IconButton disableRipple sx={maxHeight ? { padding: "4px" } : undefined}>
      <div
        className="profile_Icon" 
      >
        <img 
          src={icon} 
          alt="not-found" 
          width={width || "80px"} 
          style={{
            backgroundColor: props.openProfilePopup ? ThemeProperties.purpleSelected  : "transparent", 
            padding: maxHeight ? "2px" : "5px",
            borderRadius:"4px",
            ...(maxHeight ? { maxHeight, objectFit: "contain" } : {})
          }}
        />
      </div>
    </IconButton>
  }
  
  const GetLogo = () => {
    // Org logo in the top-right slot, from org meta globalConfig.branding.
    // Falls through to the legacy per-org logos when not configured.
    const branding = getOrgBranding();
    if (branding.profileLogo) {
      return <OrgLogoComponent
        icon={branding.profileLogo}
        width={branding.profileLogoWidth}
        maxHeight={branding.profileLogoMaxHeight || "32px"}
      />
    }

    const orgName = cookies.get("orgName")
    
    switch (orgName) {
      case 'Vammo':
        return <OrgLogoComponent icon={Vammo}/>
      case 'ckersfinance':
        return <OrgLogoComponent icon={Cker}/>
      case 'bnext':
        return  <OrgLogoComponent icon={Bnext} width="100px"/>
      default:
        return <IconButton><GetAvatar/></IconButton>
    }
  };

  return (
    <>
      {props.showIcon ? <GetLogo/> : <GetAvatar/>}
    </>
  );
}

export default ProfileAvatar;
